import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

export type TagDetailOption = {
	label: string
	value: string
}

type TagDetailsResponse = {
	tagDetailName: string
	tagDetailValue: TagDetailOption[]
}

const getTagDetails = async (tagDetailName: string): Promise<TagDetailsResponse> => {
	const response = await fetchWithAuthorizationHeader(
		`${CONSTANT.TAG_DETAILS_API_URL}?tagDetailName=${encodeURIComponent(tagDetailName)}`
	)
	const payload = await response.json()
	const body = typeof payload.body === 'string'
		? JSON.parse(payload.body)
		: payload.body ?? payload
	const result = Array.isArray(body) ? body[0] : body

	return result as TagDetailsResponse
}

export default getTagDetails